import { logger, metrics } from './slardar-utils'

export const videoStaticLabel =
  'news|newcar|guide|industry|motor|usage|evaluating|tiche|travel|offroad|modification|learn|culture|used|touring|acing|tech|skill'

/**
 * url 转 pageId
 * 可以通过两种方式:
 *  1. url (优先级高)
 *  2. RegExp
 * 注意：
 *  1. 避免影响埋点数据。 如果新增，请在page-enter.test.ts中增加测试case. 并保证 npm run test 验证通过
 *  2. 如果正则方式，尽量/^ $/ 开头和结尾严格匹配
 */
const PAGE_ID_2_URL_MAP: {
  [key: string]: {
    url?: string
    reg?: RegExp
  }
} = {
  // url...
  page_main_new: {
    url: '/',
  },
  page_section_combine_pc: {
    url: '/video/groups',
  },
  page_video_combine_pc: {
    reg: new RegExp(
      `^/video(?:s/((${videoStaticLabel})(?:-[^/]+)?)(?:/([1-9]\\d*))?)?$`
    ),
  },
  page_feed_article_mix: {
    url: '/feed',
  },
  page_search_result_new: {
    url: '/search',
  },
  page_404: {
    url: '/404',
  },
  page_car_picture: {
    url: '/picture',
  },
  page_hot_series_rank_list: {
    url: '/popular',
  },
  page_motor_forum: {
    url: '/car_fans_community',
  },
  page_dcar_live_main: {
    url: '/live',
  },
  page_series_configuration: {
    // 复杂正则在SCM编译产物检验会失败，采用非严格的匹配
    // reg: /^\/auto\/params-carIds(-x-(\d+)|(?<=carIds)(-\d+)+)$/,
    reg: /^\/auto\/params-carIds-/,
  },
  page_new_car_rank_list: {
    url: '/newcar',
  },
  page_dcd_list: {
    reg: /sales(\/*)?/,
  },
  page_dcar_motor_show: {
    url: '/activity/car_show',
  },
  page_dcar_origin_list: {
    url: '/video/groups-origin',
  },
  page_car_model_comparison: {
    url: '/auto/auto_compare/params',
  },
  page_car_zonghe_comparison: {
    url: '/auto/auto_compare/composites',
  },
  page_sell_car_publish_implement: {
    url: '/usedcar/sale',
  },
  page_sell_car_success: {
    url: '/usedcar/sale/result',
  },
  // reg...
  page_section_detail_pc: {
    reg: /^\/video\/groups\/(\d+)/,
  },
  page_car_series_pc: {
    reg: /^\/auto\/library/,
  },
  page_pgc_video_detail: {
    reg: /^\/video\/(\d+)/,
  },
  page_car_series_home: {
    reg: /^\/auto\/series\/(\d+)$/,
  },
  page_car_series_dcd_score_home: {
    reg: /^\/auto\/series\/score\/(\d|x)(.*)$/,
  },
  page_pgc_article_detail: {
    reg: /^\/article\/(\d+)/,
  },
  page_ugc_detail: {
    reg: /^\/ugc\/article\/[0-9-]+$/,
  },
  page_answer_detail: {
    reg: /^\/ugc\/article\/\d+\/answer\/\d+$/,
  },
  page_my_collection: {
    reg: /^\/user\/favor(\/)?(\d+)?/,
  },
  page_personal_homepage: {
    reg: /^\/user\/?(\w+)?\/?(\d+)?/,
  },
  page_feed_article_mix_static: {
    reg: /^\/news/,
  },
  page_user_profile: {
    reg: /^\/user\/profile\/(\d+)/,
  },
  page_series_real_picture: {
    reg: /^\/auto\/series\/(\d+)\/images-[\w]+$/,
  },
  page_series_video_list: {
    reg: /^\/auto\/series\/(\d+)\/video(.*)$/,
  },
  page_series_article_list: {
    reg: /^\/auto\/series\/(\d+)\/article(.*)$/,
  },
  page_series_qa_list: {
    reg: /^\/auto\/series\/(\d+)\/qa$/,
  },
  page_series_instruction_video_detail: {
    reg: /^\/auto\/series\/(\d+)\/videoManual\/(\d+)$/,
  },
  page_series_picture_detail: {
    reg: /^\/series-(\d+)\/images\/(.+)/,
  },
  page_series_inquiry: {
    reg: /^\/dealer\/(\d+)(\/(sale|presell|stagingpurchase|testrun))?$/,
  },
  page_series_compare_detail: {
    reg: /^\/auto\/compare\/(\d+),(\d+)/,
  },
  page_ugc_forum_home: {
    // /community/96/wenda-release-2
    reg: /^\/community\/(\d+)(?:\/([^-0-9]+)?(?:-([^-0-9]+))?(?:-?([1-9][0-9]*))?)?/,
  },
  page_reputation_detail: {
    reg: /^\/koubei\/(.+)$/,
  },
  page_dcar_origin_detail: {
    reg: /^\/video\/groups-origin\/(\d+)/,
  },
  page_topic_talk_details: {
    reg: /\/topic\/(\d+)(?:\/(complex|video|picture|qa)?(?:-([^-0-9]+))?(?:-?([1-9][0-9]*))?)?/,
  },
  page_used_car_source_detail: {
    reg: /^\/usedcar\/(\d+)$/,
  },
  page_used_car_source_list: {
    reg: /^\/usedcar\/(.+)$/,
  },
  page_buy_car_pc_tag: {
    reg: /^\/tag\/(model|series)\/(\d+)$/,
  },
  page_topic_word_information: {
    reg: /^\/tag\/pgc\/(\d+)$/,
  },
  page_car_friend_communication: {
    reg: /^\/tag\/ugc\/(\d+)$/,
  },
  page_car_style_home: {
    reg: /^\/auto\/series\/(\d+)\/model-(\d+)$/,
  },
  page_price_calculator: {
    reg: /^\/calculator\/(fullpayment|loan)$/,
  },
  page_quality_qa_detail: {
    reg: /^\/bdwenda\/(\d+)/,
  },
  page_dealer_detail: {
    reg: /^\/agent\/(\d+)$/,
  },
  page_coupon_collection: {
    reg: /^\/agent\/(\d+)\/coupon-(\d+)$/,
  },
  page_registration: {
    reg: /^\/agent\/(\d+)\/activity-(\d+)$/,
  },
  page_professional_evaluation_web: {
    reg: /^\/test\/(.+)$/,
  },
  page_tensofmillions_car_parameter: {
    reg: /section\/(\d+)-(\d+)-(\d+)$/,
  },
}

interface IPageIdInfo {
  pageId: string
  rule: {
    url?: string
    reg?: RegExp
  }
  matches?: any[]
}

const getPageIdInfo = (urlStr: string): IPageIdInfo | undefined => {
  if (!urlStr) {
    return
  }

  let url = urlStr.split('?').length > 0 ? urlStr.split('?')[0] : ''
  url = url.split('#').length > 0 ? url.split('#')[0] : ''

  //search by url
  const hitUrlPageId = Object.keys(PAGE_ID_2_URL_MAP).find((pageId) => {
    return PAGE_ID_2_URL_MAP[pageId]?.url === url
  })

  if (hitUrlPageId) {
    return {
      pageId: hitUrlPageId,
      rule: PAGE_ID_2_URL_MAP[hitUrlPageId],
    }
  }

  //search by reg
  let matches
  const hitRegPageId = Object.keys(PAGE_ID_2_URL_MAP).find((pageId) => {
    const reg = PAGE_ID_2_URL_MAP[pageId]?.reg
    if (!reg) {
      return false
    }

    matches = url?.match(reg)
    if (!matches) {
      return false
    }

    return true
  })

  if (hitRegPageId) {
    return {
      pageId: hitRegPageId,
      rule: PAGE_ID_2_URL_MAP[hitRegPageId],
      matches,
    }
  }

  metrics.counter('lib_page_enter_get_pageId_fail')
  logger.error(`[lib_page_enter_get_pageId_fail] url=${url}`)
}

export const getPageId = (url: string) => {
  const result = getPageIdInfo(url)
  return result?.pageId
}

export interface IStatData {
  page_id: string
  group_id?: string
  car_series_id?: string
  compare_series_id?: string
  user_id?: string
  column_id?: string
  current_pic_rank?: string
  section_id?: string
}

type IGetStatData = (urlStr: string) => IStatData

const getStatData: IGetStatData = (urlStr: string) => {
  let params: IStatData = {
    page_id: '',
  }

  const pageIdInfo = getPageIdInfo(urlStr)
  if (!pageIdInfo) {
    return params
  }

  const pageId = pageIdInfo?.pageId
  params = {
    page_id: pageId,
  }

  const matches = pageIdInfo?.matches
  if (matches) {
    const m1 = matches?.[1]
    Object.assign(params, {
      group_id: m1,
      car_series_id: m1,
      user_id: m1,
      column_id: m1,
      section_id: m1,
    })

    if (matches?.length >= 2) {
      if (pageId === 'page_series_compare_detail') {
        params.compare_series_id = matches[2] || ''
      }
    }
  }

  return params
}

export default getStatData
